import { Inject } from '@odinjs/odin';

import { Endpoint, FormViewService, ProviderAccreditationPendenciesService, ToastService } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { FetchAPI, FormAPI, PanelAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { AccreditationBankDataAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { AccreditationSteps } from './accreditation-update-controller';

@Controller({ fragment: FragmentNames.ACCREDITATION_BANK_DATA })
class AccreditationBankDataController extends BaseController {

  @Inject(Aliases.PANEL_PENDENCIES)
  private panelPendencies: PanelAPI;
  @Inject(Aliases.TOAST_PENDENCIES)
  private toastPendencies: ToastNotificationAPI;
  @Inject(Aliases.FETCH_BANK_DATA)
  private fetchBackData: FetchAPI;

  @OnMount(Aliases.FETCH_BANK_DATA)
  onMountFetchDocs(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;

    api.setParameters({ nrSeqProvider, nrSeqAccreditation });
    api.forceFetch();
  }

  @OnSubmit(Aliases.FORM_BANK_DATA)
  onSubmitBankData(event: SubmitEvent): void {
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    const body = event.record;
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.BANK_DATA, { nrSeqProvider, nrSeqAccreditation }, { body })
      .then(() => {
        this.fetchBackData.setParameters({ nrSeqProvider, nrSeqAccreditation });
        this.fetchBackData.forceFetch();
        ToastService.open({ message: MessageService.translate('provider.request-sucessfull'), level: ToastLevel.SUCCESS });
      }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR }));

  }

  @OnMount(Aliases.FORM_BANK_DATA)
  onMountFormSpecialty(event: MountEvent): void {
    const api = event.target as FormAPI;
    FormViewService.shouldEditForm(api, AccreditationSteps.BANK_DATA);
  }

  @OnMount(Aliases.FETCH_PENDENCIES)
  onMountFetchPendendies(event: MountEvent): void {
    ProviderAccreditationPendenciesService.fetchCardPendencies(event, AccreditationSteps.BANK_DATA);
  }

  @OnAfterFetch(Aliases.FETCH_PENDENCIES)
  onAfterFetch(event: FetchEvent): void {
    if (isEmptyArrayOrObject(event.data)) {
      this.panelPendencies.setVisible(false);
    } else {
      ProviderAccreditationPendenciesService.setMessageToastPendency(this.toastPendencies, event);
    }
  }

}

export default AccreditationBankDataController;
